import React from "react";
import { 
  HiOutlineMail, 
  HiOutlinePhone, 
  HiOutlineMapPin,
  HiOutlineClock 
} from "react-icons/hi2";
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn 
} from "react-icons/fa";
import "../asset/css/contact.css";
import { MdMailOutline } from "react-icons/md";

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form logic here
    alert("Message Sent Successfully!");
  };

  return (
    <section className="contact-page">
      {/* Header Section */}
      <div className="contact-header text-center text-white d-flex align-items-center justify-content-center">
        <div className="container">
          <h1 className="fw-bold display-4">Contact Us</h1>
          <p className="lead">Have questions? We're here to help you 24/7.</p>
        </div>
      </div>

      <div className="container contact-wrapper">
        <div className="row g-0 shadow-lg rounded-4 overflow-hidden bg-white">
          
          {/* Left Side: Contact Information */}
          <div className="col-lg-5 contact-info-panel p-4 p-md-5 text-white">
            <h3 className="fw-bold mb-4">Contact Information</h3>
            <p className="text-white-50 mb-5">
              Reach out to us through any of these channels or fill out the form. 
              Our team will get back to you within 24 hours.
            </p>

            <div className="d-flex align-items-start mb-4">
              <div className="info-icon-box me-3">
                <HiOutlinePhone />
              </div>
              <div>
                <h6 className="mb-1 fw-bold">Phone</h6>
                <p className="small mb-0">+91 9412991272 , +91 9897373444</p>
              </div>
            </div>

            <div className="d-flex align-items-start mb-4">
              <div className="info-icon-box me-3">
                <MdMailOutline />
              </div>
              <div>
                <h6 className="mb-1 fw-bold">Email</h6>
                <p className="small mb-0">a2zyatra2012@gmail.com</p>
              </div>
            </div>

            <div className="d-flex align-items-start mb-4">
              <div className="info-icon-box me-3">
                <HiOutlineMapPin />
              </div>
              <div>
                <h6 className="mb-1 fw-bold">Office</h6>
                <p className="small mb-0">Bholagiri Road, Haridwar, Uttrakhand (249401)</p>
              </div>
            </div>

            <div className="d-flex align-items-start mb-5">
              <div className="info-icon-box me-3">
                <HiOutlineClock />
              </div>
              <div>
                <h6 className="mb-1 fw-bold">Working Hours</h6>
                <p className="small mb-0">Mon - Sat: 10:00 AM - 08:00 PM</p>
              </div>
            </div>

            <div className="social-links d-flex gap-3 mt-auto">
              <a href="#" className="social-icon"><FaFacebookF /></a>
              <a href="#" className="social-icon"><FaTwitter /></a>
              <a href="#" className="social-icon"><FaInstagram /></a>
              <a href="#" className="social-icon"><FaLinkedinIn /></a>
            </div>
          </div>

          {/* Right Side: Contact Form */}
          <div className="col-lg-7 p-4 p-md-5">
            <h3 className="fw-bold text-dark mb-4 text-center text-lg-start">Send us a Message</h3>
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label small fw-bold">Full Name</label>
                  <input type="text" className="form-control custom-input" placeholder="John Doe" required />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-bold">Email Address</label>
                  <input type="email" className="form-control custom-input" placeholder="john@example.com" required />
                </div>
                <div className="col-12">
                  <label className="form-label small fw-bold">Subject</label>
                  <input type="text" className="form-control custom-input" placeholder="Booking Inquiry" required />
                </div>
                <div className="col-12">
                  <label className="form-label small fw-bold">Message</label>
                  <textarea className="form-control custom-input" rows="5" placeholder="Write your message here..." required></textarea>
                </div>
                <div className="col-12 mt-4">
                  <button type="submit" className="btn btn-teal-submit w-100 py-3 fw-bold shadow-sm">
                    SEND MESSAGE
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Google Maps Integration */}
        {/* <div className="mt-5 rounded-4 overflow-hidden shadow-sm border" style={{ height: '350px' }}>
          <iframe 
            title="Office Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d119066.41709401923!2d79.00246603058862!3d21.159340291992984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c0a5a31faf13%3A0x19b37d25110fe4ca!2sNagpur%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" 
            width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy">
          </iframe>
        </div> */}
      </div>
    </section>
  );
};

export default Contact;